export const DOES_NOT_REPEAT = 'Does Not Repeat';
export const DAILY = 'Daily';
export const WEEKLY = 'Weekly';
export const BIWEEKLY = 'Biweekly';
export const MONTHLY = 'Monthly';
export const EVERY_THREE_MONTHS = 'Every 3 months';
export const EVERY_SIX_MONTHS = 'Every 6 months';
export const YEARLY = 'Yearly';
export const START_DATE = 'start';
export const END_DATE = 'end';
